module.exports = __webpack_public_path__ + "img/avatar2.dfefba84.png";